import { render } from "./CellLoaderBox.vue?vue&type=template&id=e7d5a0b2&scoped=true&ts=true"
import script from "./CellLoaderBox.vue?vue&type=script&lang=ts"
export * from "./CellLoaderBox.vue?vue&type=script&lang=ts"

import "./CellLoaderBox.vue?vue&type=style&index=0&id=e7d5a0b2&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d5a0b2"]])

export default __exports__